import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useGuild } from '../config/context/guild'
import {
  filterChildrenByAccess,
  filterMenuItemsByAccess,
  isMenuPathActive,
  MenuItem,
} from './menuAccess'

const linkClassName = cn(
  'flex min-h-11 items-center rounded-md border bg-card-nested px-3 py-2.5 text-sm font-medium transition-colors',
  'hover:bg-accent hover:text-accent-foreground',
  'data-active:text-primary',
)

const EntityMenuMobileList = ({ menuItems }: { menuItems: MenuItem[] }) => {
  const { guild, teamReference } = useGuild()
  const { pathname } = useLocation()

  const menuItemsWithAccess = filterMenuItemsByAccess(
    menuItems,
    guild,
    teamReference,
  )

  if (!menuItemsWithAccess.length) return null

  return (
    <nav className='flex flex-col gap-1.5'>
      {menuItemsWithAccess.map((item) => {
        const childrenWithAccess = filterChildrenByAccess(
          item,
          guild,
          teamReference,
        )

        if (childrenWithAccess.length > 1) {
          return childrenWithAccess.map((child) => (
            <Link
              key={child.path}
              to={child.path}
              data-active={
                isMenuPathActive(pathname, child.path, child.exact) || undefined
              }
              className={linkClassName}
            >
              <span className='text-muted-foreground'>{item.name}</span>
              <ChevronRight className='mx-1 h-3.5 w-3.5 shrink-0 text-muted-foreground' />
              <span>{child.name}</span>
            </Link>
          ))
        }

        const target =
          childrenWithAccess.length === 1 ? childrenWithAccess[0] : item

        return (
          <Link
            key={item.path}
            to={target.path}
            data-active={
              isMenuPathActive(pathname, target.path, target.exact) || undefined
            }
            className={linkClassName}
          >
            {target.name}
          </Link>
        )
      })}
    </nav>
  )
}

export default EntityMenuMobileList
